import React from 'react';

export default ({ label, name, className, errors = [], ...props }) => {
  return (
    <div className={className }>
      {label && (
        <label className="form-label w-72" htmlFor={name}>
          {label}:
        </label>
      )}
        <br/>
      <input
        id={name}
        name={name}
        {...props}
        className={`form-input w-full ${errors.length ? 'error' : ''}`}
      />
      {errors && <div className="form-error">{errors}</div>}
    </div>
  );
};
